module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA0ElEQVR4AWMYHODrTJX/j50V/t9RkScJI5vx38OC+/+nLuX/D8wVyDMAhA1U2f//O6j2/32d8v97eiQaAMNy4iz/Ly2R//93t9r/N7lK/+9qkGBATk7Of3V19f88nEz/t/dL//9/XO3/7y2q/1/GKxE2ICoq6j8IuLq6gg1jY2X8f3iGLMgQMH4Rpfj/WZAibgOYmZn/h4SE/FdRUcF0QaIS8WEgIczy/8x8uf9/9wLDIB8YBlokhIGuMjAWDkNjwYCcdNBDZjr4NpfMlDg8AABW/jlZYDoCYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TL.png
// module id = 1281
// module chunks = 0